/**
 * Shared formatting helpers for the report formatters: the translator contract, the date/number
 * helpers and the two small lookups the app used to own (a user's full name and a sequence's status
 * label key). Kept in the engine so the app table and the server export format rows identically.
 */
import { PatientTherapySequenceStatus } from '../database/schema.js';
import { toDate } from '../util/functions.js';
import { format } from 'date-fns';
const DATE_FORMAT = 'dd.MM.yyyy';
/** Drops the empty lines from a stacked cell. */
export function compact(lines) {
    return lines.filter((line) => Boolean(line));
}
/** DD.MM.YYYY for a cell value; null when the value is absent or invalid. */
export function formatReportDate(value) {
    const date = toDate(value);
    return date ? format(date, DATE_FORMAT) : null;
}
/** HH:mm for a cell value; null when the value is absent or invalid. */
export function formatReportTime(value) {
    const date = toDate(value);
    return date ? format(date, 'HH:mm') : null;
}
/** A user's display name, title first (e.g. "Dr Anna Muller"); '' when there is no user. */
export function fullNameOf(user) {
    if (!user)
        return '';
    const name = [user.firstName, user.lastName].filter(Boolean).join(' ');
    return user.title ? `${user.title.trim()} ${name}`.trim() : name;
}
export function sequenceStatusLabelKey(sequence, patientArrivalEnabled = true) {
    if (!sequence?.status)
        return null;
    if (sequence.status === PatientTherapySequenceStatus.enum.validating) {
        if (!sequence.pharmacistValidatedAt)
            return 'validating.pharmacistCheck';
        // the arrival sub-step only exists while the doctorRelease setting keeps it enabled
        if (patientArrivalEnabled && !sequence.patientArrivedAt)
            return 'validating.patientArrival';
    }
    return sequence.status;
}
//# sourceMappingURL=shared.js.map